import { AuthService } from '../../../app/shared/service/auth/auth.service';
import { catchError, forkJoin, map, Observable, of, retry, tap } from 'rxjs';
import { Injectable } from '@angular/core';
import { Resolve, Router } from '@angular/router';
import { UserControlService } from '../../../app/shared/service/userControl/user-control.service';
import { CommonService } from '../../../app/shared/service/common/common.service';
import { SharedFilterService } from '../../../app/shared/service/filter-service/shared-filter.service';
import { environment } from '../../../environments/environment';
import { UserAppsImageName } from '../../../app/shared/lib/model/common';
import { AppRoutes } from '../lib/api-constant';

@Injectable()
export class UserSettingsResolver{
    userDetails: any = {};
    constructor(
        private userControlService: UserControlService,
        private router: Router,
        private commonService: CommonService,
        private authService: AuthService,
        private appService: UserControlService,
        private sharedFilterService:SharedFilterService,
        private userService: UserControlService) {

    }

    resolve(): Observable<any> {
        return forkJoin([
            this.userControlService.getUserFeaturesWithPrivileges().pipe(),
            this.userControlService.getCompanyDetails().pipe(
                retry(3)  // Retry up to 3 times before failing
            ),
            this.appService.getAllApps().pipe(
                map((response: any) => response) // Ensure the response is typed correctly
            ),
        ]).pipe(
            tap(([permissions,companies,allapps]) => {
                // Store the responses in a shared service for use across the app
                //   this.configService.setConfig(config);
                this.userControlService.updateUserSettings(permissions.data);
                if (companies && companies.status === 200) {
                    this.sharedFilterService.setCompanyList(companies.data);
                  if(allapps){
                    let apps = (allapps as any).data.map((app:any) => ({
                        ...app,
                        value: app.appCd,
                        label: app.appNm,
                        url: app.linkAddress,
                        logo: "",
                        logoLight: `${environment.appIconBaseUrl}${app?.appCd.toLowerCase()}_light.png`,
                        logoDark: `${environment.appIconBaseUrl}${app?.appCd.toLowerCase()}_dark.png`
                    })).filter((app:any) => app.activeYn === "Y");

                    this.appService.updateUserApps(apps);
                  }
            }}),
            catchError((error) => {
                //  this.router.navigate([AppRoutes.AuthAbstract.ACCESS]);
                // console.error('Error loading initial data:', error);
                return of([]); // Handle error gracefully
            })
        );
   
    }

}